import React, { FC } from 'react';

import { CommonError } from 'src/components/common-error/common-error';
import { i18n } from 'src/i18n';
import { monkeyImageProps } from 'src/resources/images';

export const PageNotAvailable: FC = () => (
  <CommonError
    title={i18n.page.error.notAvailable.title}
    subtitle={[i18n.page.error.notAvailable.mainSubtitle, i18n.page.error.notAvailable.subtitle]}
    image={monkeyImageProps}
  />
);
